/**
 * The GPS entry's hash: one entry for a point that moves. It belongs to the
 * device and is never synced. A leaf module, so the other MyWeather modules
 * (and the hooks) import it without a cycle through `./index`.
 */
export const USER_LOCATION_HASH = 'userLocation';
